<template>
  <b-col
    cols="6"
    md="3"
    class="gold d-flex justify-content-center"
    v-if="image"
  >
    <a
      :href="url"
      target="_blank"
      class="d-flex align-items-center justify-content-center"
    >
      <img
        v-if="image"
        class=""
        :src="$_addToUrl(image, cloudinaryParams)"
        alt
      />
    </a>
  </b-col>
</template>
  
<script>
import { helperMethods } from "../mixins/helpers";

export default {
  mixins: [helperMethods],
  props: ["url", "image"],
  data() {
    return {
      cloudinaryParams: "q_auto",
    };
  },
};
</script>
  
  <style lang="scss" scoped>
@import "../styles/variables.scss";

.gold {
  max-height: 193px;
}

.gold > a {
}
p {
  text-align: left;
}

.sponsors {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
.sponsors .silver {
  max-width: 50%;
}
.sponsors img {
  max-width: 100%;
  object-fit: contain;
}
.sponsors h2 {
  color: $pink;
}
.sponsors a {
  border: 3px solid black;
  display: block;
  text-align: center;
  background-color: white;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Sponsor.vue